// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tracking-number[data-v-a535539e]{max-width:100%;cursor:pointer}.tracking-number[data-v-a535539e]:hover{text-decoration:underline}.tracking-number-wrap[data-v-a535539e]{max-width:100%;width:-moz-fit-content;width:fit-content;height:21px;padding-top:1px}", ""]);
// Exports
module.exports = exports;
